import * as React from "react";
const stopPropagation = (evt) => {
  evt.stopPropagation();
  evt.preventDefault();
};
const StopPropagation = ({
  children = void 0,
  className = void 0
}) => /* @__PURE__ */ React.createElement("span", { role: "presentation", onClick: stopPropagation, onMouseDown: stopPropagation, className }, children);
export default StopPropagation;
